import { AbstractControl, MaxLengthValidator } from '@angular/forms';

export function ValidatePhoneNumber(control: AbstractControl) {
    if((control.value.length < 10 || control.value.length > 10 ) ){
       return {invalidNumber : true}
      }
      return null;
}

export function ValidateEmail(control: AbstractControl) {

  

    let format = /\s+$/
    if (format.test(control.value)) { 
      
        return { invalidEmail: true }
    }

    let format1 = /[!#$%^&*()+\=\[\]{};':"\\|,<>?\/\s]+/
    if (format1.test(control.value)) {
        return { invalidEmail: true }
    }


    if((control.value.length > 50 ) ){
       return {invalidEmail : true}
      }
      return null;
}